@if (isLoading) {
  <app-loading-page [message]='loadingMessage'></app-loading-page>
}
@else {
  @if (selectedOrganizationDetails) {
    <!-- DETAILS VIEW -->
    <div class="header-button-combo contained no-stack">
      <div>
        <button kendoButton class="btn-back" (click)="backToList()">
          Back
        </button>  
      </div>
      <div>
        @if (isEditable) {
          <button kendoButton class="btn-save" (click)="saveOrganizationDetails()" [disabled]="!selectedOrganizationDetails.Dirty">
            Save
          </button>
        }
      </div>
    </div>
    <div class="component-block">
      <div class="input-wrapper">
        <label>Name</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.Name"/>
          <img class="details-logo" [src]="selectedOrganizationDetails.LogoURL || 'assets/favicon.png'" alt="Organization Logo" />
        }
        @else {
          <span>{{ selectedOrganizationDetails.Name }}</span>
          <img class="details-logo" [src]="selectedOrganizationDetails.LogoURL || 'assets/favicon.png'" alt="Organization Logo" />
        }
      </div>

      @if (selectedOrganizationDetails.Parent) {
        <div class="input-wrapper">
          <label>Parent</label>
          <span>{{ selectedOrganizationDetails.Parent }}</span>
        </div>
      }

      <div class="input-wrapper">
        <label>Description</label>
        @if (isEditable) {
          <textarea kendoTextArea [(ngModel)]="selectedOrganizationDetails.Description"></textarea>
        }
        @else {
          <span>{{ selectedOrganizationDetails.Description }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>Created</label>
        <span>{{ selectedOrganizationDetails.__mj_CreatedAt | date }}</span>
      </div>

      <div class="input-wrapper">
        <label>Domain</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.Domain"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.Domain }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>Website</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.Website"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.Website }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>Logo URL</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.LogoURL"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.LogoURL }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>Address</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.AddressLine1"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.AddressLine1 }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>City</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.City"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.City }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>State</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.State"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.State }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>Postal Code</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.PostalCode"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.PostalCode }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>Country</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.Country"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.Country }}</span>
        }
      </div>

      <div class="input-wrapper">
        <label>Phone Number</label>
        @if (isEditable) {
          <input kendoTextBox [(ngModel)]="selectedOrganizationDetails.Phone"/>
        }
        @else {
          <span>{{ selectedOrganizationDetails.Phone }}</span>
        }
      </div>
    </div>
  }
  @else {

      <div class="header-button-combo contained">
        <div>
          <h2>Organizations</h2>
        </div>
        <div>
          <button kendoButton class="btn-add" (click)="newOrganization()">New Organization</button>
        </div>
      </div>
      <div class="organizations-list">
        @for (organization of organizations; track organization) {
          <div class="component-block organization-item">
            <div class="organization-item__name">
              <!-- Organization Logo -->
              <img
                [src]="organization.LogoURL || 'assets/favicon.png'"
                alt="Organization Logo"
              />
              <!-- Organization Name (clickable) -->
              {{ organization.Name }}
            </div>
            <!-- Optional Tags -->
            @if (currentOrganization && organization.ID === currentOrganization.ID) {
              <div class="organization-item__tag">
                <span class="pill">Current</span>
              </div>
            }
            <!-- Action Buttons: Switch and Leave -->
            <div class="organization-item__actions">
              @if(organization.ID !== currentOrganization.ID) {
                <button
                  kendoButton
                  (click)="switchOrganization(organization)"
                >
                  Switch
                </button>
              }
              <button
                class="btn-delete"
                look="outline"
                kendoButton
                (click)="openLeaveDialog(organization)"
              >
                Leave
              </button>
            </div>
            <a (click)="openOrganizationDetails(organization)" class="absolute-link"></a>
          </div>
        }
      </div>
  }
}
  
<!-- Leave Confirmation Dialog -->
@if (selectedOrganizationToLeave && !isLoading) {
  <kendo-dialog>
      <kendo-dialog-titlebar>
          Confirm Leave Organization
      </kendo-dialog-titlebar>
      <p class="confirmation-message">
          Are you sure you want to leave {{ selectedOrganizationToLeave?.Name }}? You will lose access to all AskSkip instances and contacts in this Organization.
      </p>
      <div class="btn-group">
          <button kendoButton (click)="confirmLeave()">Confirm</button>
          <button kendoButton look="outline" (click)="cancelLeave()" [primary]="false">Cancel</button>
      </div>
  </kendo-dialog>
}
